// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"Team_searchInput_h4G6v","searchIcon":"Team_searchIcon_EvaQw"};